import {apiClient, Promotion, Amenity, Page, LoyaltyActivity} from "rp-components"
import {StoreLinks} from "@/store/modules/LoyaltyStore"

export interface LoyaltyService {
    listPromotions(propertyId: number, amenityId: string): Promise<Promotion[]>
    getPromotion(propertyId: number, amenityId: string, promotionId: string): Promise<Promotion>
    savePromotion(promotion: Promotion): Promise<Promotion>
    listAmenities(propertyId: number): Promise<Amenity[]>
    getAmenity(propertyId: number, amenityId: string): Promise<Amenity>
    getPromotionActivities(propertyId: number, amenityId: string, promotionId: string, minPageSize: number): Promise<Page<LoyaltyActivity>>
    nextActivityPage(uri: string, minPageSize: number): Promise<Page<LoyaltyActivity>>
    reverseLoyaltyPunch(propertyId: number, amenityId: string, promotionId: string, loyaltyActivityId: string): Promise<LoyaltyActivity>
    getStoreLinks(): Promise<StoreLinks>
}

class LoyaltyServiceImpl implements LoyaltyService {
    static instance?: LoyaltyService = undefined

    private constructor() {}

    static getInstance(): LoyaltyService {
        if (LoyaltyServiceImpl.instance == undefined) {
            LoyaltyServiceImpl.instance = new LoyaltyServiceImpl()
        }
        return LoyaltyServiceImpl.instance
    }

    async listPromotions(propertyId: number, amenityId: string): Promise<Promotion[]> {
        return apiClient.get(`properties/${propertyId}/amenities/${amenityId}/promotions?includeExpired=true`)
    }

    async getPromotion(propertyId: number, amenityId: string, promotionId: string): Promise<Promotion> {
        return apiClient.get(`properties/${propertyId}/amenities/${amenityId}/promotions/${promotionId}`)
    }

    async savePromotion(promotion: Promotion): Promise<Promotion> {
        return apiClient.post<Promotion, Promotion>(`properties/${promotion.propertyId}/amenities/${promotion.amenityId}/promotions`, promotion)
    }

    async listAmenities(propertyId: number): Promise<Amenity[]> {
        return apiClient.get<Amenity[]>(`properties/${propertyId}/pogo-perks/amenities`)
    }

    async getAmenity(propertyId: number, amenityId: string): Promise<Amenity> {
        return apiClient.get<Amenity>(`/properties/${propertyId}/amenities/${amenityId}`)
    }

    async getPromotionActivities(propertyId: number, amenityId: string, promotionId: string, minPageSize: number): Promise<Page<LoyaltyActivity>> {
        const params = {
            minPageSize: minPageSize
        }
        return apiClient.getPage<LoyaltyActivity>(`properties/${propertyId}/amenities/${amenityId}/promotions/${promotionId}/activity`, params)
    }

    async nextActivityPage(uri: string, minPageSize: number): Promise<Page<LoyaltyActivity>> {
        return apiClient.getNextPage(uri, minPageSize)
    }

    async reverseLoyaltyPunch(propertyId: number, amenityId: string, promotionId: string, loyaltyActivityId: string): Promise<LoyaltyActivity> {
        return apiClient.delete<LoyaltyActivity>(`properties/${propertyId}/amenities/${amenityId}/promotions/${promotionId}/activity/${loyaltyActivityId}`)
    }

    async getStoreLinks(): Promise<StoreLinks> {
        return apiClient.get<StoreLinks>(`/appstore/links`)
    }
}

export default LoyaltyServiceImpl.getInstance()